import React, { FC } from 'react';
import { css } from '@emotion/core';

import { alignItemsCenter, center, flex, spaceGapCompact } from '@/styles';
import SfxIcon from '@/components/primitive/sfx-icon';
import { DOT_RADIUS } from '@/components/composed/new-slo-views/expanded/graph/constants';

import { captionPrefixStyles } from './styles';
import LowTrafficTag from './low-traffic-tag';

const badgeStyles = css`
  width: ${DOT_RADIUS * 2}px;
  height: ${DOT_RADIUS * 2}px;
  box-sizing: border-box;
  border-radius: 50%;
  display: inline-flex;
  ${center};
  font-weight: bold;
  font-size: ${DOT_RADIUS}px;
`;

const getBadgeEventStyles = (isBold: boolean, primaryColor: string, textColor: string) => css`
  background-color: ${primaryColor};
  border: 2px solid ${isBold ? primaryColor : textColor};
  color: ${textColor};
`;

type EventsBadgeProps = {
  count: number;
  backgroundColor: string;
  textColor: string;
  caption: string | JSX.Element;
  useWithSfxIcon?: boolean;
  useLowTrafficTag?: boolean;
  isBold?: boolean;
  showLowTrafficTooltip?: boolean;
};

const EventsBadge: FC<EventsBadgeProps> = ({
  count,
  isBold = false,
  backgroundColor,
  textColor,
  caption,
  useWithSfxIcon = false,
  useLowTrafficTag = false,
  showLowTrafficTooltip = false,
}) => (
  <div css={[flex, alignItemsCenter, spaceGapCompact]}>
    <div css={[badgeStyles, getBadgeEventStyles(isBold, backgroundColor, textColor)]}>{count}</div>
    <strong>{caption}</strong>
    {useLowTrafficTag && <LowTrafficTag showLowTrafficTooltip={showLowTrafficTooltip} />}
    {useWithSfxIcon && (
      <>
        <span css={captionPrefixStyles}>with</span>
        <SfxIcon />
      </>
    )}
  </div>
);

export default EventsBadge;
